export const employeeApprovalRuleTypes={
    PURCHASE:'purchase',
    STOCK_REQUEST:'stock_request'
};